// extracted by mini-css-extract-plugin
module.exports = {"articleAuthor":"ArticleAuthor-module--articleAuthor--JU5MJ"};